/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Period_TitleInputs */

const en_directory_promotion_period_title = /** @type {(inputs: Directory_Promotion_Period_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the campaign period`)
};

const zh_directory_promotion_period_title = /** @type {(inputs: Directory_Promotion_Period_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置推广周期`)
};

/**
* | output |
* | --- |
* | "Set the campaign period" |
*
* @param {Directory_Promotion_Period_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_period_title = /** @type {((inputs?: Directory_Promotion_Period_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Period_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_period_title(inputs)
	return zh_directory_promotion_period_title(inputs)
});
export { directory_promotion_period_title as "directory.promotion.period_title" }